<template>
  <div class="goodList">
    <el-table v-show="goodList.length" :data="goodList" border>
      <el-table-column prop="date" label="商品信息" minWidth="150">
        <template slot-scope="scope">
          <div class="good-info" @click="goDetail(scope.row)">
            <el-image
              v-show="scope.row.fileUrl"
              :src="scope.row.fileUrl"
              class="goodsImg"
              fit="contain"
            >
              <template slot="error">
                <img src="~@/assets/img/bitmap.png" class="goodsImg" />
              </template>
            </el-image>
            <img src="~@/assets/img/bitmap.png" v-show="!scope.row.fileUrl" />
            <div class="good-basic">
              <Tooltip
                class="good-spu-name"
                :innerContent="scope.row.name || '-'"
              />
              <div class="good-spu-code">
                {{ $t("product.supplyCommodityCode") }}：{{
                  scope.row.supplyCommodityCode
                }}
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="brandName" label="品牌"> </el-table-column>
      <el-table-column prop="seriesName" label="系列"> </el-table-column>
      <el-table-column prop="sellingUnit" label="单位"> </el-table-column>
      <el-table-column prop="deliveryTime" label="供货周期(工作日)">
      </el-table-column>
      <el-table-column prop="moq" label="最小起订量"> </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="limit"
      :total="total"
      v-show="total"
      layout="total, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="getDataList"
    >
    </el-pagination>
  </div>
</template>
<script>
import Tooltip from '@/components/tooltipShow/index'
import GoodPrice from '@/components/good-price'
import { openOther } from '@/utils'
export default {
  data () {
    return {}
  },
  props: {
    goodList: {
      type: Array,
      default: () => {
        return []
      }
    },
    page: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 20
    }
  },
  components: {
    GoodPrice,
    Tooltip
  },
  methods: {
    pageSizeChangeHandle (val) {},
    // 跳转页
    getDataList (val) {
      this.$emit('refushDataList', val)
    },
    // 跳转详情页
    goDetail (goods) {
      openOther(`selectionInquiryDetail?spuId=${goods.spuId}&skuId=`)
    }
  }
}
</script>
<style lang="scss" scoped>
.goodList {
  .good-info {
    display: flex;
    align-items: center;
    img {
      object-fit: contain;
      width: 76px;
      height: 76px;
      margin-right: 5px;
    }
    .el-image {
      width: 76px;
      height: 76px;
      margin-right: 5px;
    }
    .good-basic {
      width: 215px;
      font-size: 14px;
      line-height: 20px;
      .good-spu-name {
        color: #333;
      }
      .good-spu-code {
        color: #666;
        margin-top: 5px;
      }
    }
  }
}
</style>
